/**
 * https://linear.app/goodcover/issue/GC-33#comment-11702c35
 *
 * @type {{zipCode: string, title: string, url: string}[]}
 */
const Geo = [
  {
    title: 'LA County',
    zipCode: '90405',
    url: 'la-county',
    state: 'California',
  },
  {
    title: 'Southern California',
    zipCode: '92105',
    url: 'southern-california',
    state: 'California',
  },
  {
    title: 'Sacramento Metro',
    zipCode: '95815',
    url: 'sacramento-metro',
    state: 'California',
  },
  {
    title: 'Orange County',
    zipCode: '92606',
    url: 'orange-county',
    state: 'California',
  },
  {
    title: 'the Bay Area',
    zipCode: '94110',
    url: 'bay-area',
    state: 'California',
  },
]

module.exports = Geo
